// extracted by mini-css-extract-plugin
export default {"root":"jM5BK","th":"_2XRdr","td":"_1_Fek","leadingTd":"j5_6v","leadingTh":"_3y7aa","tr":"_25Fxa","oddRow":"_2wmmN","evenRow":"_2vqQA","isChildren":"_2Hx_k"};